import { $actionEvent } from '@/actions/actionEvent';
import { $highlight } from '@/components/selection';
import type { Vector2 } from '@/utils/vec';

export function moveHighlight(delta: Vector2) {
  $actionEvent.emit('highlight', {
    pos: $highlight.get().add(delta).max(0),
  });
}

export function expandHighlight(delta: Vector2) {
  $actionEvent.emit('expandHighlight', {
    delta,
  });
}
